import React, { useContext } from 'react';
import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import { CMSModule, MetadataContext } from '@/components';
import classNames from 'classnames';

type SectionElementModel = ModuleBaseModel<
  {
    anchor: string;
    content: ModuleBaseModel<ModuleBasePropsModel>[];
    summary: string;
    title: string;
  } & ModuleBasePropsModel
>;

const SectionElement = (data: SectionElementModel) => {
  const {
    props: { anchor, content, backgroundColour },
  } = data;

  const { isPublic } = useContext(MetadataContext);

  if (!content) return null;

  return (
    <div
      id={anchor}
      className={classNames(
        'SectionElement',
        'lg:[&_.RichTextModule_.richText]:px-1 [&_.RichTextModule:not(.pb-8)]:pb-3 [&_.RichTextModule:not(.pt-8)]:pt-3',
        'print:[&_.richText]:w-full print:[&_.section-heading]:w-full print:[&_section.module:not(.QuoteModule)]:!bg-transparent',
        isPublic &&
          '[&_.ImageVideoX2Block_.container]:justify-start [&_.ImagesRowModule_.ImageContainer]:mx-[initial] [&_.MultimediaItem_.MediaElement]:mx-[initial] [&_.RichTextModule_.richText]:mx-[initial] xl:[&_.RichTextModule_.richText_li]:!text-2xl xl:[&_.RichTextModule_.richText_li]:!leading-[30px] xl:[&_.RichTextModule_.richText_p]:!text-2xl xl:[&_.RichTextModule_.richText_p]:!leading-[30px] [&_.SectionHeadingModule_.SectionHeading]:mx-[initial] [&_.SectionHeadingModule_.SectionHeading]:px-0',
      )}
      style={{
        backgroundColor: backgroundColour,
        pageBreakBefore: 'always',
      }}
    >
      {content?.map((module) => (
        <CMSModule key={module.id} module={module} />
      ))}
    </div>
  );
};

export default SectionElement;
